import { Table, type Column } from '../../../components/ui/Table';
import type { ComplianceEvent } from '../../../types/api';
import { formatDateTime } from '../../../utils/formatters';
import { getComplianceEventLabel } from '../lib/labels';

interface ComplianceEventsTableProps {
  events: ComplianceEvent[];
}

export const ComplianceEventsTable = ({
  events,
}: ComplianceEventsTableProps) => {
  const columns: Column<ComplianceEvent>[] = [
    {
      key: 'event_type',
      header: 'Evento',
      render: (value: ComplianceEvent['event_type']) =>
        getComplianceEventLabel(value),
    },
    {
      key: 'created_at',
      header: 'Fecha',
      render: (value: string) => formatDateTime(value),
    },
  ];

  return (
    <Table
      data={events}
      columns={columns}
      keyExtractor={(event) => event.id}
      emptyMessage="Sin eventos registrados."
      aria-label="Historial de eventos de cumplimiento"
    />
  );
};

ComplianceEventsTable.displayName = 'ComplianceEventsTable';
